import { render, staticRenderFns } from "./ToolbarAvatar.vue?vue&type=template&id=79b70de1&scoped=true"
import script from "./ToolbarAvatar.vue?vue&type=script&lang=js"
export * from "./ToolbarAvatar.vue?vue&type=script&lang=js"
import style0 from "./ToolbarAvatar.vue?vue&type=style&index=0&id=79b70de1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b70de1",
  null
  
)

export default component.exports